import { Fragment, ReactNode, useState } from 'react'
import { isNil } from 'lodash'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

import { UploadDocumentType } from '@/constants/businessConstants'
import { useReselector } from '@/utils/sharedHooks'
import { TypographyStyles, TextColors } from '@/styles'
import { Button, Link, Popup, Text } from '@/ui'
import { getUserDocumentsByCategoryInternalName } from '@/features/user/your-practice/documents/lib/userDocuments.selector'

// TODO: Migrate to V2 skipcq: JS-0099
import { selectUserDocumentCategoryByInternalName } from '@/featuresV1/Admin/UserDocumentCategories/userDocumentCategories.selectors'
import FileUploadModal from '@/componentsV1/FileUpload/FileUploadModal'

export const PracticeProfileEntry = ({
  label,
  value,
  popupContent,
  documentCat,
  documentType = UploadDocumentType.TAX,
  taxYear,
}: {
  label: string
  value?: string | number | undefined | null
  popupContent?: ReactNode
  documentCat?: string
  documentType?: UploadDocumentType
  taxYear?: string
}) => {
  const [modelOpen, setModalOpen] = useState(false)

  const taxDocCat = useReselector(
    selectUserDocumentCategoryByInternalName,
    documentCat
  )

  const userDocs = useReselector(
    getUserDocumentsByCategoryInternalName,
    documentCat
  )

  return (
    <>
      <div className="flex flex-row gap-2">
        <div className="w-full md:w-3/10">
          <Text variant={TypographyStyles.LABEL_SM}>
            {label}
            {popupContent && <Popup content={popupContent} />}
          </Text>
        </div>
        <div className="w-full md:w-7/10">
          {!isNil(value) && (
            <Text variant={TypographyStyles.BODY_SM} color={TextColors.MUTED}>
              {value}
            </Text>
          )}
          {userDocs.map((doc) => (
            <Fragment key={doc.id}>
              {doc?.signedUrl ? (
                <Link
                  href={doc.signedUrl}
                  variant="primary"
                  color={TextColors.MUTED}
                >
                  {doc?.fileDescription}
                </Link>
              ) : (
                <Text
                  variant={TypographyStyles.BODY_SM}
                  color={TextColors.MUTED}
                >
                  {doc?.fileDescription}
                </Text>
              )}
            </Fragment>
          ))}
          {taxDocCat && !userDocs.length && (
            <Button
              variant="secondary"
              onClick={() => setModalOpen(true)}
              iconLeft={regular('upload')}
              size="sm"
            >
              Upload
            </Button>
          )}
        </div>
        <FileUploadModal
          open={modelOpen}
          close={() => setModalOpen(false)}
          userFacing
          documentType={documentType}
          categoryId={taxDocCat?.id}
          year={taxYear}
        />
      </div>
      <div className="h-4" />
    </>
  )
}
